import { cn } from "@ui/utils"

import { UserAvatar } from "./user-avatar"

interface CollaboratorsProps {
  userIds: string[]
  className?: string
  size?: "sm" | "md" | "xs"
  onRemove?: (userId: string) => void
  overlap?: "tight" | "loose"
  twoInitials?: boolean
}

export function Collaborators({
  userIds,
  className = "",
  onRemove,
  size = "md",
  overlap = "tight",
  twoInitials = false,
}: CollaboratorsProps) {
  return (
    <div className={`flex ${className}`}>
      {userIds.map((userId, index) => (
        <div
          key={`${userId}-${index}`}
          className={cn(
            "bg-secondary text-secondary-foreground flex items-center rounded-full p-px text-sm font-medium transition-all duration-150",
            index === 0 ? "ml-0" : overlap === "loose" ? "-ml-1" : "-ml-3",
            {
              "group-hover:ml-1": !!onRemove && index !== 0,
            }
          )}
          style={{ zIndex: userIds.length - index }}
        >
          <UserAvatar
            userId={userId}
            size={size}
            onRemove={!!onRemove ? onRemove : undefined}
            twoInitials={twoInitials}
          />
        </div>
      ))}
    </div>
  )
}
